import React from 'react';
import {
	Card,
	CardContent,
	Typography,
	Grid,
	Icon,
	Tooltip,
	Button,
	CircularProgress
} from '@material-ui/core';

function isEmptyOrSpaces(str) {
	return (
		str === undefined || str === null || str.toString().match(/^ *$/) !== null
	);
}

const todoCard = props => {
	return (
		<Card>
			<Grid container>
				<Grid
					item
					xs={9}
					sm={9}
					md={10}
					style={{ borderRight: '1px solid #cccccc69' }}
				>
					<CardContent>
						<Typography variant="subheading">{props.title}</Typography>
						<div
							style={{
								borderBottom: '1px solid #cccccc69',
								margin: '5px auto',
								width: '100%'
							}}
						/>
						<Typography variant="body2" className="todoDesc">
							{props.desc}
						</Typography>
						<div
							style={{
								borderBottom: '1px solid #cccccc69',
								margin: '5px auto',
								width: '100%'
							}}
						/>
						<Typography variant="caption">
							Created: {props.date_created}
						</Typography>
						{props.due_date ? (
							<Typography variant="caption">
								Due: {props.due_date}
							</Typography>
						) : null}

						<div style={{ display: 'flex', marginTop: '15px' }}>
							<Typography variant="caption">
								<strong>Assigned To:</strong>{' '}
							</Typography>
							{!isEmptyOrSpaces(props.assigned_user_fullname) ? (
								<React.Fragment>
									<Typography variant="caption" style={{ marginLeft: '10px' }}>
										{props.assigned_user_fullname}
									</Typography>

									<Tooltip
										title={
											props.todo_assigned_done
												? 'Completed by Assignee'
												: 'Not yet completed by Assignee'
										}
									>
										<Icon
											fontSize="small"
											style={{
												color: props.todo_assigned_done ? 'green' : '#ff721f',
												marginLeft: '10px',
												position: 'relative',
												bottom: '5px'
											}}
										>
											check_circle_outline
										</Icon>
									</Tooltip>
								</React.Fragment>
							) : (
								<Typography variant="caption" style={{ marginLeft: '10px' }}>
									None
								</Typography>
							)}
						</div>
						<Typography variant="caption">
							<strong>Client:</strong>{' '}
							{!isEmptyOrSpaces(props.client_fullname)
								? props.client_fullname
								: 'None'}
						</Typography>
					</CardContent>
				</Grid>
				<Grid item xs={3} sm={3} md={2} style={{ textAlign: 'center' }}>
					{props.loadingAction ? (
						<div style={{ marginTop: '10px' }}>
							<CircularProgress size={20} />
						</div>
					) : (
						<Grid container>
							<Grid item xs={12} sm={12} md={12} style={{ marginTop: '10px' }}>
								<Tooltip
									title={
										props.done ? "Move back to Current Todo's" : 'Mark as done'
									}
								>
									<Button
										variant="fab"
										mini
										color="secondary"
										aria-label="Edit"
										className="semiSmallFab"
										onClick={props.doneToggle}
									>
										<Icon style={{ color: 'white' }}>
											{props.done ? 'add' : 'check'}
										</Icon>
									</Button>
								</Tooltip>
							</Grid>
							{props.done ? null : (
								<Grid
									item
									xs={12}
									sm={12}
									md={12}
									style={{ marginTop: '10px' }}
								>
									<Tooltip title="Click to edit">
										<Button
											variant="fab"
											mini
											color="primary"
											aria-label="Edit"
											className="semiSmallFab"
											onClick={props.handleEdit}
										>
											<Icon style={{ color: 'white' }}>create</Icon>
										</Button>
									</Tooltip>
								</Grid>
							)}
							<Grid item xs={12} sm={12} md={12} style={{ marginTop: '10px' }}>
								<Tooltip title={'Delete'}>
									<Button
										variant="fab"
										mini
										style={{ backgroundColor: '#ff721f' }}
										aria-label="Delete"
										className="semiSmallFab"
										onClick={props.handleDelete}
									>
										<Icon style={{ color: 'white' }}>delete_outline</Icon>
									</Button>
								</Tooltip>
							</Grid>
						</Grid>
					)}
				</Grid>
			</Grid>
		</Card>
	);
};

export default todoCard;



// WEBPACK FOOTER //
// ./src/views/Todos/components/TodoCard.jsx